<template>
  <v-container>
    <v-layout
      text-center
      wrap
    >
    CMS 로그 (이벤트 등록, 템플릿 등록)
    
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import store from '../../store';
export default {
//   name: 'SideChapterInfo',
  data() {
    return {

    }
  },
  created() {
      console.log('CREATE EVENT HOME ');
  },
  computed: {
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  methods: {
    ...mapActions([
    ]),

    },
};
</script>
